// extracted by mini-css-extract-plugin
export var deleteIcon = "_k5-5";
export var deleteOption = "_k5-3";
export var divider = "_k5-2";
export var downloadIcon = "_k5-4";
export var drawer = "_k5-0";
export var drawerFooter = "_k5-6";
export var drawerOpen = "_k5-1";
export var highlighted = "_k5-7";
export var lighterHighlight = "_k5-8";